import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
export interface ChartSeries {
    name: string;
    data: number[];
    color: string;
}
export interface MultiLineChartProps {
    categories: string[];
    series: ChartSeries[];
    height?: number;
    tooltipRenderer?: (ctx: {
        seriesName: string;
        x: string;
        y: number;
        color: string;
        avatar?: string;
    }) => string;
}
const MultiLineChart: React.FC<MultiLineChartProps> = ({
    categories,
    series,
    height = 350,
    tooltipRenderer
}) => {
    const options: Highcharts.Options = {
        chart: {
            type: "spline",
            height,
            backgroundColor: "transparent",
            spacing: [10, 10, 15, 10]
        },

        title: { text: "" },

        xAxis: {
            categories,
            tickmarkPlacement: "on",
            lineColor: "#e5e7eb",
            labels: {
                style: {
                    color: "#6b7280",
                    fontSize: "12px"
                }
            }
        },

        yAxis: {
            title: { text: "" },
            gridLineColor: "#f1f5f9",
            labels: {
                style: {
                    color: "#6b7280",
                    fontSize: "12px"
                }
            }
        },

        legend: {
            enabled: false,
        },

        tooltip: {
            useHTML: true,
            backgroundColor: "transparent",
            borderWidth: 0,
            shadow: false,
            padding: 0,
            shared: false,

            formatter: function (this: any) {
                const series = this.series;
                const color = series.color as string;

                const x = String(this.key);
                const y = Number(this.y);

                const avatar = series.options.custom?.avatar;

                return tooltipRenderer?.({
                    seriesName: series.name,
                    x,
                    y,
                    color,
                    avatar
                }) ?? "";
            }
        },

        plotOptions: {
            series: {
                lineWidth: 2,
                marker: {
                    enabled: false,
                    states: {
                        hover: {
                            enabled: true,
                            radius: 6,
                            lineWidth: 3,
                            lineColor: "#fff"
                        }
                    }
                },
                states: {
                    inactive: {
                        opacity: 0.15   // 👈 fade other lines
                    },
                    hover: {
                        lineWidth: 3
                    }
                },
                stickyTracking: false
            }
        },

        credits: { enabled: false },

        series: series.map((s: any) => ({
            type: "spline",
            name: s.name,
            data: s.data,
            color: s.color,
            visible: s.visible !== false,
            custom: s.meta
        })) as Highcharts.SeriesOptionsType[]

    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default MultiLineChart;
